<p-dialog
    [(visible)]="visible"
    [modal]="true"
    [closable]="true"
    header="Select the Episode you want to Move the Selected Sub-Entities to"
    appendTo="body"
    [style]="{ 'max-width': '750px', width: '100%', 'max-height': '425px' }">
    <span class="p-input-icon-left mt-2 w-12">
        <i class="pi pi-search"></i>
        <input
            type="text"
            id="episode-name-input"
            #episodeNameInput
            pInputText
            placeholder="Start typing to search episodes by name..."
            class="w-12" />
    </span>

    <div *miproLoading="loadingEpisodes; diameterPx: '35px'" class="mt-2">
        <div *ngFor="let episode of filteredEpisodes; index as episodeIndex; trackBy: episodeIndex">
            <div class="flex mb-2">
                <episode-header-v2 class="flex-1" [episode]="episode" [showPlusButton]="false" [showEllipsisButton]="false">
                </episode-header-v2>

                <p-radioButton
                    class="ml-2"
                    [value]="episode.id"
                    [(ngModel)]="selectedEpisodeId"
                    [ngModelOptions]="{ standalone: true }"></p-radioButton>
            </div>
        </div>
        <empty-list *ngIf="filteredEpisodes?.length === 0"></empty-list>
    </div>

    <p-footer>
        <button pButton type="button" label="Cancel" class="p-button-secondary" (click)="visible = false">
            <i class="material-icons">clear</i>
        </button>

        <button
            pButton
            type="button"
            [disabled]="!selectedEpisodeId"
            label="Move to Selected Episode"
            class="m-button-primary"
            (click)="selectEpisode()"></button>
    </p-footer>
</p-dialog>
